import React from 'react';
import { Divider, Typography } from 'antd';
import {
  GET_CB_SOCIAL_MEDIA_FLOW_SETTINGS,
  GET_SOCIAL_MEDIA_INTEGRATION_SETTINGS,
} from 'api/social-media-integration/queries';
import {
  SET_CB_SOCIAL_MEDIA_FLOW_SETTINGS,
  SET_SOCIAL_MEDIA_INTEGRATION_SETTINGS,
} from 'api/social-media-integration/mutations';
import SocialMediaFlowSettingForm from './components/SocialMediaFlowSettingForm/SocialMediaFlowSettingForm';
import styles from './SocialMediaIntegrationSettings.module.scss';

const { Title } = Typography;

const SocialMediaIntegrationSettings = (): JSX.Element => (
  <div className={styles.root}>
    <Title level={2}>Social Media Integration Settings</Title>
    <Divider />

    <SocialMediaFlowSettingForm
      title="Account Integration Flow"
      description="Controls access to the social-media account integration flow."
      checkboxLabel="Enable New Social Media Integration Flow"
      query={GET_SOCIAL_MEDIA_INTEGRATION_SETTINGS}
      mutation={SET_SOCIAL_MEDIA_INTEGRATION_SETTINGS}
      queryField="getSocialMediaIntegrationSettings"
    />

    <Divider />

    <SocialMediaFlowSettingForm
      title="CB Campaign Social Media Flow"
      description="Controls connected-account enforcement, social-media post metrics pulling, and intention scores for campaigns."
      checkboxLabel="Enable CB Campaign Social Media Flow"
      query={GET_CB_SOCIAL_MEDIA_FLOW_SETTINGS}
      mutation={SET_CB_SOCIAL_MEDIA_FLOW_SETTINGS}
      queryField="getCbSocialMediaFlowSettings"
    />
  </div>
);

export default SocialMediaIntegrationSettings;
